@if (
  {
    fetching: (hotelAvalibilityService.fetching | async)
  };
  as data
) {
  <app-filters-slider>
    <div class="hotel_filter_options_content" id="filters">
      @if (amenityTypeList.length) {
        <div class="filters-group">
          <fieldset>
            <legend class="flex-row-container">
              <h5>
                <b i18n="@@filterHotelsAmenities">Amenities</b>
              </h5>
              @if (!amenitiesShowMore && amenityTypeList.length > 5) {
                <span
                  class="hotel-filters-show-more"
                  (click)="amenitiesShowMore = true; setFocus('toggle_amenities_button')"
                  (keydown.enter)="amenitiesShowMore = true; setFocus('toggle_amenities_button')"
                  (keydown.space)="amenitiesShowMore = true; setFocus('toggle_amenities_button')"
                  tabindex="0"
                  role="button"
                  i18n-aria-label
                  id="toggle_amenities_button"
                  aria-label="Show more amenities filters"
                  i18n="@@filterHotelsShowMore"
                >
                  Show more
                  <i class="ico-chevron-down" aria-hidden="true"></i>
                </span>
              }
              @if (amenitiesShowMore && amenityTypeList.length > 5) {
                <span
                  class="hotel-filters-show-more"
                  (click)="amenitiesShowMore = false; setFocus('toggle_amenities_button')"
                  (keydown.enter)="amenitiesShowMore = false; setFocus('toggle_amenities_button')"
                  (keydown.space)="amenitiesShowMore = false; setFocus('toggle_amenities_button')"
                  tabindex="0"
                  role="button"
                  i18n-aria-label
                  id="toggle_amenities_button"
                  i18n="@@filterHotelsShowLess"
                  aria-label="Show less amenities filters"
                >
                  Show less
                  <i class="ico-chevron-up" aria-hidden="true"></i>
                </span>
              }
            </legend>
            <div class="flex-column-container">
              @for (x of amenityTypeList; track x; let i = $index) {
                <span
                  [ngClass]="{ display_none: i > 4 && !amenitiesShowMore }"
                  class="flex-row-container align-items-end"
                >
                  <mat-checkbox
                    color="primary"
                    class="light-primary"
                    name="{{ x }}"
                    value="{{ x }}"
                    id="filter-checkbox-{{ x }}"
                    (change)="applyFilter($event, x, 'amenitytype')"
                    (keydown.enter)="applyFilter($event, x, 'amenitytype')"
                    [(ngModel)]="checkboxStates.facilities[x]"
                    (keydown.esc)="closeFiltersOptions()"
                  >
                    {{ getAmenitiesDisplayText(x) | translate }}
                  </mat-checkbox>

                  @if (x === AmenitiesSearchHandler.ELECTRIC_CAR_CHARGING_POINT) {
                    <section (mouseleave)="tt1.close()" class="container">
                      <button
                        type="button"
                        class="accessible-tooltip-trigger ico ico-info-circle"
                        placement="top"
                        i18n-ngbTooltip
                        triggers="manual"
                        #tt1="ngbTooltip"
                        (mouseenter)="tt1.open()"
                        (focus)="tt1.open()"
                        (blur)="tt1.close()"
                        (click)="tt1.toggle()"
                        attr.aria-label="Electric charging points may be available onsite or offsite at the hotels closest available car park, please check the hotel website for more information."
                        ngbTooltip="Electric charging points may be available onsite or offsite at the hotels closest available car park, please check the hotel website for more information."
                      >
                        <span class="visuallyhidden"
                          >Electric charging points may be available onsite or offsite at the hotels
                          closest available car park, please check the hotel website for more
                          information.</span
                        >
                      </button>
                    </section>
                  }
                  @if (x === AmenitiesSearchHandler.PETS_ALLOWED) {
                    <section (mouseleave)="tt1.close()" class="container">
                      <button
                        type="button"
                        class="accessible-tooltip-trigger ico ico-info-circle"
                        placement="top"
                        i18n-ngbTooltip
                        triggers="manual"
                        #tt1="ngbTooltip"
                        (mouseenter)="tt1.open()"
                        (focus)="tt1.open()"
                        (blur)="tt1.close()"
                        (click)="tt1.toggle()"
                        attr.aria-label="Additional charges may apply, please contact the hotel directly."
                        ngbTooltip="Additional charges may apply, please contact the hotel directly."
                      >
                        <span class="visuallyhidden"
                          >Additional charges may apply, please contact the hotel directly.</span
                        >
                      </button>
                    </section>
                  }
                </span>
              }
            </div>
          </fieldset>
        </div>
      }
      <div class="filters-group">
        <fieldset>
          <legend>
            <h5>
              <b i18n="@@travelPolicy">Travel Policy</b>
            </h5>
          </legend>
          <div class="flex-column-container">
            @for (x of travelPolicies; track x; let i = $index) {
              <span>
                <mat-checkbox
                  color="primary"
                  class="light-primary"
                  name="{{ x }}"
                  value="{{ x }}"
                  id="filter-checkbox-{{ x }}"
                  (change)="applyFilter($event, x, 'travelPolicy')"
                  (keydown.enter)="applyFilter($event, x, 'travelPolicy')"
                  [(ngModel)]="checkboxStates.travelPolicy[x]"
                  (keydown.esc)="closeFiltersOptions()"
                >
                  {{ x | translate }}
                </mat-checkbox>
              </span>
            }
          </div>
        </fieldset>
      </div>
      <div class="filters-group">
        <fieldset>
          <legend>
            <h5>
              <b i18n="@@filterHotelsExtra">Extra</b>
            </h5>
          </legend>
          @for (x of extra; track x) {
            <div [hidden]="searchParams.hiddenExtraFilters[x]">
              <mat-checkbox
                color="primary"
                class="light-primary"
                name="{{ x }}"
                value="{{ x }}"
                id="filter-checkbox-{{ x }}"
                (change)="applyFilter($event, x, 'extra')"
                (keydown.enter)="applyFilter($event, x, 'extra')"
                [(ngModel)]="checkboxStates.extra[x]"
                (keydown.esc)="closeFiltersOptions()"
              >
                {{ getExtraDisplayString(x) | translate }}
              </mat-checkbox>
            </div>
          }
          @for (x of refundableRoomTypeList; track x) {
            <div [hidden]="searchParams.hiddenExtraFilters[x]">
              <mat-checkbox
                color="primary"
                class="light-primary"
                name="{{ x }}"
                value="{{ x }}"
                id="filter_checkbox_{{ x }}"
                (change)="applyFilter($event, x, 'refundableRoomType')"
                (keydown.enter)="applyFilter($event, x, 'refundableRoomType')"
                [(ngModel)]="checkboxStates.refundable[x]"
              >
                {{ x | splitCamelCase | translate }}
              </mat-checkbox>
            </div>
          }
          <span class="extra_amenities">
            <!--Requested under Extras but actually filters by amenity type-->
            <mat-checkbox
              color="primary"
              class="light-primary"
              name="{{ ExtraSearchHandler.CTM_PARTNERS }}"
              value="{{ ExtraSearchHandler.CTM_PARTNERS }}"
              id="filter-checkbox-ctm"
              (change)="applyFilter($event, ExtraSearchHandler.CTM_PARTNERS, 'amenitytype')"
              (keydown.enter)="applyFilter($event, ExtraSearchHandler.CTM_PARTNERS, 'amenitytype')"
              [(ngModel)]="checkboxStates.amenityTypes[ExtraSearchHandler.CTM_PARTNERS]"
              (keydown.esc)="closeFiltersOptions()"
              [hidden]="searchParams.hiddenExtraFilters[ExtraSearchHandler.CTM_PARTNERS]"
            >
              @if (!isScion) {
                <span i18n="@@filterHotelsCTMBusinessReady"> CTM Partners - Business Ready </span>
              }
              @if (isScion) {
                <span i18n="@@hoterates_accreditation_header2">Business Ready</span>
              }
            </mat-checkbox>
            <mat-checkbox
              color="primary"
              class="light-primary"
              name="{{ ExtraSearchHandler.GREEN_HOTEL }}"
              value="{{ ExtraSearchHandler.GREEN_HOTEL' }}"
              id="filter-checkbox-green"
              (change)="applyFilter($event, ExtraSearchHandler.GREEN_HOTEL, 'amenitytype')"
              (keydown.enter)="applyFilter($event, ExtraSearchHandler.GREEN_HOTEL, 'amenitytype')"
              [(ngModel)]="checkboxStates.amenityTypes[ExtraSearchHandler.GREEN_HOTEL]"
              (keydown.esc)="closeFiltersOptions()"
              [hidden]="searchParams.hiddenExtraFilters[ExtraSearchHandler.GREEN_HOTEL]"
            >
              @if (!isScion) {
                <span i18n="@@filterHotelsCTMGreenerChoice"> CTM Greener Choice </span>
              }
              @if (isScion) {
                <span i18n="@@flightDetails_greenerChoiseHeader2">Greener Choice</span>
              }
            </mat-checkbox>
            <mat-checkbox
              color="primary"
              class="light-primary"
              id="filter-checkbox-fcdo"
              [name]="hotelTagEnum.FCDOApprovedHotel"
              [value]="hotelTagEnum.FCDOApprovedHotel"
              (change)="applyFilter($event, hotelTagEnum.FCDOApprovedHotel, 'amenitytype')"
              (keydown.enter)="applyFilter($event, hotelTagEnum.FCDOApprovedHotel, 'amenitytype')"
              [(ngModel)]="checkboxStates.extra[hotelTagEnum.FCDOApprovedHotel]"
              (keydown.esc)="closeFiltersOptions()"
              i18n="@@filterHotelsFCDO"
              [hidden]="
                !isFCDOApprovedHotel ||
                searchParams.hiddenExtraFilters[ExtraSearchHandler.FCDO_HOTEL]
              "
            >
              FCDO Approved Hotel
            </mat-checkbox>
            <span
              [hidden]="searchParams.hiddenExtraFilters[ExtraSearchHandler.ACCESSIBLE_ROOM]"
              class="flex-row-container align-items-end"
            >
              <mat-checkbox
                color="primary"
                class="light-primary"
                id="filter-checkbox-accessible"
                [name]="hotelTagEnum.AccessibleRoom"
                [value]="hotelTagEnum.AccessibleRoom"
                (change)="applyFilter($event, hotelTagEnum.AccessibleRoom, 'accessibleRoomType')"
                (keydown.enter)="
                  applyFilter($event, hotelTagEnum.AccessibleRoom, 'accessibleRoomType')
                "
                [(ngModel)]="checkboxStates.amenityTypes[hotelTagEnum.AccessibleRoom]"
                (keydown.esc)="closeFiltersOptions()"
                i18n="@@filterHotelsAR"
              >
                Accessible Room
              </mat-checkbox>
              <section (mouseleave)="ttAR.close()" class="container">
                <button
                  type="button"
                  class="accessible-tooltip-trigger ico ico-info-circle"
                  placement="top"
                  i18n-ngbTooltip
                  i18n-aria-label
                  triggers="manual"
                  #ttAR="ngbTooltip"
                  (mouseenter)="ttAR.open()"
                  (focus)="ttAR.open()"
                  (blur)="ttAR.close()"
                  (click)="ttAR.toggle()"
                  attr.aria-label="The hotel have confirmed this room meets ADA standards."
                  ngbTooltip="The hotel have confirmed this room meets ADA standards."
                >
                  <span class="visuallyhidden"
                    >The hotel have confirmed this room meets ADA standards.</span
                  >
                </button>
              </section>
            </span>
          </span>
        </fieldset>
      </div>
      <div class="filters-group">
        <fieldset>
          <legend>
            <h5>
              <b i18n="@@filterHotelsBreakfast">Breakfast</b>
            </h5>
          </legend>
          @for (x of breakfastFilters; track x; let i = $index) {
            <span class="flex-row-container align-items-end">
              <mat-checkbox
                color="primary"
                class="light-primary"
                name="{{ x }}"
                value="{{ x }}"
                id="filter-checkbox-{{ x }}"
                (change)="applyFilter($event, x, 'breakfastType')"
                (keydown.enter)="applyFilter($event, x, 'breakfastType')"
                [(ngModel)]="checkboxStates.breakfast[x]"
                (keydown.esc)="closeFiltersOptions()"
              >
                {{ x | translate }}
              </mat-checkbox>
              @if (x === SearchHandler.BREAKFAST_INCLUDED) {
                <section (mouseleave)="ttip.close()" class="container">
                  <button
                    type="button"
                    class="accessible-tooltip-trigger ico ico-info-circle"
                    i18n-ngbTooltip
                    i18n-aria-label
                    triggers="manual"
                    placement="top"
                    #ttip="ngbTooltip"
                    (mouseenter)="ttip.open()"
                    (focus)="ttip.open()"
                    (blur)="ttip.close()"
                    (click)="ttip.toggle()"
                    aria-label="Hotel rates may include breakfast; however, this is not guaranteed. Please refer to the specific booking policy or the full rate description for confirmation."
                    ngbTooltip="Hotel rates may include breakfast; however, this is not guaranteed. Please refer to the specific booking policy or the full rate description for confirmation."
                  >
                    <span class="visuallyhidden" i18n="@@filterHotelsMayIncludeBreakfast">
                      Hotel rates may include breakfast; however, this is not guaranteed. Please
                      refer to the specific booking policy or the full rate description for
                      confirmation.
                    </span>
                  </button>
                </section>
              }
            </span>
          }
        </fieldset>
      </div>
      <div class="filters-group">
        <fieldset>
          <legend>
            <h5>
              <b i18n="@@filterHotelsPreference">Preference</b>
            </h5>
          </legend>
          <div class="flex-column-container">
            @for (x of preferred; track x) {
              <span>
                <mat-checkbox
                  color="primary"
                  class="light-primary"
                  name="{{ x }}"
                  id="filter-checkbox-{{ x }}"
                  value="{{ x }}"
                  (change)="applyFilter($event, x, 'preferred')"
                  (keydown.enter)="applyFilter($event, x, 'preferred')"
                  [(ngModel)]="checkboxStates.preference[x]"
                  (keydown.esc)="closeFiltersOptions()"
                >
                  {{ x | translate }}
                </mat-checkbox>
              </span>
            }
          </div>
        </fieldset>
      </div>
      @if (hotelAvalibilityService.hasSabreCSLResults) {
        <div class="filters-group">
          <fieldset>
            <legend>
              <h5>
                <b i18n="@@filterHotelsStarRating">Star Rating</b>
              </h5>
            </legend>
            @for (x of starRating; track x) {
              <span [hidden]="searchParams.hiddenStarRatingFilters[x] || hotelStarRatingsToHide[x]">
                <mat-checkbox
                  color="primary"
                  class="light-primary"
                  name="{{ x }}"
                  id="filter-checkbox-{{ x }}"
                  value="{{ x }}"
                  (change)="applyFilter($event, x, 'starRating')"
                  (keydown.enter)="applyFilter($event, x, 'starRating')"
                  [(ngModel)]="checkboxStates.starRating[x]"
                  (keydown.esc)="closeFiltersOptions()"
                >
                  {{ x | translate }}
                </mat-checkbox>
              </span>
            }
          </fieldset>
        </div>
      }
      <div class="filters-group">
        <fieldset>
          <legend>
            <h5>
              <b i18n="@@filterRoomType">Room Type</b>
            </h5>
          </legend>
          <div class="flex-column-container">
            @for (x of roomTypeList; track x) {
              <span>
                <mat-checkbox
                  color="primary"
                  class="light-primary"
                  name="{{ x }}"
                  value="{{ x }}"
                  id="filter-checkbox-{{ x }}"
                  (change)="applyFilter($event, x, 'roomType')"
                  (keydown.enter)="applyFilter($event, x, 'roomType')"
                  [(ngModel)]="checkboxStates.preference[x]"
                  (keydown.esc)="closeFiltersOptions()"
                >
                  {{ x | translate }}
                </mat-checkbox>
              </span>
            }
          </div>
        </fieldset>
      </div>
      <div>
        <div class="filters-group">
          <h5>
            <b i18n="@@filterHotelsByName">Hotel Name</b>
          </h5>
          <input
            type="text"
            id="filter-hotel-name"
            [(ngModel)]="searchParams.filters.hotelName"
            (ngModelChange)="onFilterChangeHotelName()"
            aria-label="HotelName"
            i18n-placeholder
            placeholder="Enter a Hotel Name"
          />
        </div>
        <div class="filters-group">
          <fieldset>
            <legend class="flex-row-container">
              <h5>
                <b i18n="@@filterHotelsHotelChain">Hotel Chain</b>
              </h5>
              @if (!chainsShowMore && amenityTypeList.length > 5) {
                <span
                  class="hotel-filters-show-more"
                  (click)="chainsShowMore = true; setFocus('toggle_chains_button')"
                  (keydown.enter)="chainsShowMore = true; setFocus('toggle_chains_button')"
                  (keydown.space)="chainsShowMore = true; setFocus('toggle_chains_button')"
                  tabindex="0"
                  role="button"
                  i18n-aria-label
                  aria-label="Show more chains filters"
                  id="toggle_chains_button"
                  i18n="@@filterHotelsShowMore"
                >
                  Show more
                  <i class="ico-chevron-down" aria-hidden="true"></i>
                </span>
              }
              @if (chainsShowMore && amenityTypeList.length > 5) {
                <span
                  class="hotel-filters-show-more"
                  (click)="chainsShowMore = false; setFocus('toggle_chains_button')"
                  (keydown.enter)="chainsShowMore = false; setFocus('toggle_chains_button')"
                  (keydown.space)="chainsShowMore = false; setFocus('toggle_chains_button')"
                  tabindex="0"
                  role="button"
                  i18n-aria-label
                  id="toggle_chains_button"
                  i18n="@@filterHotelsShowLess"
                  aria-label="Show less chains filters"
                >
                  Show less
                  <i class="ico-chevron-up" aria-hidden="true"></i>
                </span>
              }
            </legend>
            <div class="flex-column-container">
              @for (x of chainTypeList; track x; let i = $index) {
                <span [ngClass]="{ display_none: i > 4 && !chainsShowMore }">
                  <mat-checkbox
                    color="primary"
                    class="light-primary"
                    name="{{ x }}"
                    id="filter-checkbox-{{ x }}"
                    value="{{ x }}"
                    (change)="applyFilter($event, x, 'chain')"
                    (keydown.enter)="applyFilter($event, x, 'chain')"
                    (keydown.esc)="closeFiltersOptions()"
                    [(ngModel)]="checkboxStates.chain[x]"
                  >
                    {{ x | translate }}
                  </mat-checkbox>
                </span>
              }
            </div>
          </fieldset>
        </div>
        @if (crownSet) {
          <div class="filters-group">
            <fieldset>
              <legend>
                <h5>
                  <b i18n="@@filterHotelsCrownRates">Crown Rates</b>
                </h5>
              </legend>
              <!-- preferredCrown -->
              @for (x of preferredCrown; track x) {
                <span>
                  <mat-checkbox
                    color="primary"
                    class="light-primary"
                    name="{{ x }}"
                    id="filter-checkbox-{{ x }}"
                    value="{{ x }}"
                    (change)="applyFilter($event, x, 'crownPreferred')"
                    (keydown.enter)="applyFilter($event, x, 'crownPreferred')"
                    [(ngModel)]="checkboxStates.preferenceCrown[x]"
                    (keydown.esc)="closeFiltersOptions()"
                  >
                    {{ x | translate }}
                  </mat-checkbox>
                </span>
              }
            </fieldset>
          </div>
        }
        <div class="filters-group">
          <fieldset>
            <legend>
              <h5>
                <b i18n="@@filterHotelsPreferredRates">Preferred Rates</b>
              </h5>
            </legend>
            <div class="flex-column-container">
              <!-- preferredRateList -->
              @for (x of preferredRateList; track x) {
                <span>
                  <mat-checkbox
                    color="primary"
                    class="light-primary"
                    name="{{ x }}"
                    id="filter-checkbox-{{ x }}"
                    value="{{ x }}"
                    (change)="applyFilter($event, x, 'preferredRate')"
                    (keydown.enter)="applyFilter($event, x, 'preferredRate')"
                    [(ngModel)]="checkboxStates.preferenceRate[x]"
                    (keydown.esc)="closeFiltersOptions()"
                  >
                    {{ x | translate }}
                  </mat-checkbox>
                </span>
              }
            </div>
          </fieldset>
        </div>
      </div>
      <div>
        <div class="class_option_list filters-group">
          <h5 id="price_range"><b i18n="@@priceRange">Price Range </b></h5>
          <div class="custom-slider flex-row-container flex-column-mobile">
            <div class="flex-row-container">
              <div class="customer-slider-box">
                <label class="custom-slider-label" for="minPrice">
                  <span i18n="@@filterHotelsMinRange">Min</span>
                  <span class="visuallyhidden">&nbsp;-&nbsp;price range lower bound</span>
                </label>
                <input id="minPrice" class="price_filter_box" [(ngModel)]="minPrice" />
              </div>
              <div class="customer-slider-box">
                <label class="custom-slider-label" for="maxPrice">
                  <span i18n="@@filterHotelsMaxRange">Max</span>
                  <span class="visuallyhidden">&nbsp;-&nbsp;price range upper bound</span>
                </label>
                <input id="maxPrice" class="price_filter_box" [(ngModel)]="maxPrice" />
              </div>
            </div>
            <button appButton="small" class="cutomer-slider-filter-button" (click)="updatePrice()">
              Filter Price
            </button>
          </div>
        </div>
        <section role="region" aria-label="close" class="hotel_filter_options_clear">
          <button
            appButton="small"
            (click)="clearFilters()"
            (keydown.esc)="closeFiltersOptions()"
            i18n="@@filterhotels_clear"
            (keydown.shift.tab)="trapFocusReverse($event)"
            aria-label="Clear filters"
            id="hotel-filters-clear"
          >
            Clear
          </button>
        </section>
      </div>
    </div>
  </app-filters-slider>
}
